import React, { useState } from 'react';
import Box from '@mui/material/Box';
import BuildSearchForm from './BuildSearchForm';
import BuildSearchTable from './BuildSearchTable';
import operationsHelpers from '../../helpers/operations';

function BuildSearch(props) {

    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);
    const [orderNum, setOrderNum] = useState('');
    const [builds, setBuilds] = useState([]);

    const handleDateChange = (date, field) => {
        let func = setStartDate;
        if (field === "endDate") func = setEndDate;
        if (date !== null) {
            func({formatted: date.format("YYYY-MM-DD"), full: date});
        } else {
            func(date);
        };
    };

    const getBuilds = async () => {
        props.setLoading(true);
        try {
            const payload = {
                start_date: startDate ? startDate.formatted : null,
                end_date: endDate ? endDate.formatted : null,
                order_number: orderNum ? orderNum : null
            };
            const res = await operationsHelpers.getBuilds(payload, props.company, props.token);
            setBuilds(res);
           
        } catch(err) {
            console.log('getBuilds', err);
            props.toast.error('Failed to get builds!');
        } finally {
            props.setLoading(false);
        };
    };

    const clearBuildSearch = async () => {
        setStartDate(null);
        setEndDate(null);
        setOrderNum('');
        setBuilds([]);
    };

    const exportBuilds = async () => {
        const today = new Date();
        const formattedDate = `${today.getMonth() + 1}.${today.getDate()}.${today.getFullYear().toString().slice(-2)}`;
        let data = [
            ["order_num/pullsheet_num", "vendor_name", "sku", "quantity", "build_date", "worker", "group_number", "warehouse", "reported"].join(",")
        ];
        for (let build of builds) {
            data.push(
                [build.order_number, build.customer, build.sku, build.quantity, build.build_date, 
                `"${build.worker}"`, build.group_number, build.warehouse, build.reported].join(",")
            );
        };
        let csv = data.join("\n");
        let uri = "data:text/csv;charset=utf-8," + encodeURIComponent(csv);
        let a = document.createElement("a");
        a.setAttribute("href", uri);
        a.setAttribute("download", `${formattedDate} Builds.csv`);
        document.body.appendChild(a);
        a.click();
    };

    return(
        <Box className = {props.isMobile ? "mobile-top" : "desktop-top"} sx = {{display: 'flex', flexDirection: 'column'}}>
            <Box className = {props.isMobile ? "mobile-box" : "desktop-box"} sx = {{paddingLeft: 2}}>
                <h1>Build Search</h1>
                <BuildSearchForm
                    isMobile = {props.isMobile}
                    handleDateChange = {handleDateChange}
                    startDate = {startDate?.full}
                    endDate = {endDate?.full}
                    orderNum = {orderNum}
                    setOrderNum = {setOrderNum}
                    clearBuildSearch = {clearBuildSearch}
                    getBuilds = {getBuilds}
                    exportBuilds = {exportBuilds}
                    builds = {builds}
                />
                <BuildSearchTable 
                    isMobile = {props.isMobile}
                    builds = {builds}
                />
            </Box>
        </Box>
    )
}

export default BuildSearch;